export const CATEGORY_NAVIGATION_INITIAL_DISPLAY_LIMIT = 10;